module.exports = __webpack_public_path__ + "img/case-银江.fae2f0c8.png";